module.exports = __webpack_public_path__ + "img/pla.eb0d8100.png";